import React, { useEffect, useState } from "react";
import { Tag, ExternalLink } from "lucide-react";
import api, { fileUrl } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { useSEO } from "@/hooks/useSEO";
import { SectionHeading, EmptyState } from "@/components/shared/SectionHeading";
import { Button } from "@/components/ui/button";

export default function Offers() {
  const { t } = useLang();
  useSEO("Offers", "Current INVIXA offers and promotions.");
  const [offers, setOffers] = useState(null);
  useEffect(() => { api.get("/offers").then((r) => setOffers(r.data)).catch(() => setOffers([])); }, []);

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
      <SectionHeading eyebrow={t("nav_offers")} title="Offers & Promotions" subtitle="Current promotions from INVIXA and our partners." />
      <div className="mt-10">
        {offers === null ? <div className="text-center text-slate-500 py-20">{t("loading")}</div>
          : offers.length === 0 ? <EmptyState message="No active offers right now. Check back soon." icon={Tag} />
          : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {offers.map((o) => (
                <div key={o.id} className="card-surface hover-glow rounded-2xl overflow-hidden flex flex-col" data-testid={`offer-card-${o.id}`}>
                  {o.image_file_id && <img src={fileUrl(o.image_file_id)} alt={o.title} className="w-full h-48 object-cover" />}
                  <div className="p-6 flex-1 flex flex-col">
                    <h3 className="font-display text-xl font-semibold text-white">{o.title}</h3>
                    {o.description && <p className="mt-2 text-sm text-slate-400 flex-1">{o.description}</p>}
                    {o.cta_url && <a href={o.cta_url} target="_blank" rel="noopener noreferrer" className="mt-4"><Button className="gradient-brand text-brand-navy font-semibold">{o.cta_text || "Learn More"} <ExternalLink className="h-4 w-4 ml-1.5" /></Button></a>}
                  </div>
                </div>
              ))}
            </div>
          )}
      </div>
    </div>
  );
}
